import React from 'react'
import { Modal } from 'react-bootstrap'
import { getDomaiGetQuote } from '../../services/Utils'
import { storageData } from '../../services/Services'
import useWindowSize from '../../utils/windowUtils'

const buttonStylePrim = {
    background: '#ff8000',
    borderColor: '#ff8000',
    padding: '6px 40px',
    borderRadius: '25px'
}

const buttonStyleSec = {
    background: '#376998',
    borderColor: '#376998',
    fontSize: '.85em',
    padding: '6px 15px',
    borderRadius: '25px'
}

const RenewalAlertModal = (props) => {
    const windowSize = useWindowSize()
    const isMobile = windowSize.width < 430;
    const user = props.userData.renewalInfo;
    const formattedDate = FormatDate(new Date(user.expirationDate));
    
    const handleOnClick = (token) => {
        window.open(`https://${getDomaiGetQuote()}/renewal/mi/Renewal_0LoadPolicy.aspx?token=${token}&access=My%20Account`, '_blank');
        closeModal();
    }

    const closeModal = () => { 
        props.setShowModal(modalsList => modalsList.slice(1));
        storageData.setItem('renewalModalAnswered', true);
    }

    return (
        <>
            <Modal
                dialogClassName='modal'
                show={props.showModal}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <div className={'modalContent'}>
                    <Modal.Body
                        style={{maxHeight:(isMobile ? '600px': '')}}
                    >
                        <div>
                            <div className={'dialogContent1'}>
                                <div className='roundyDown' />
                                {(
                                    user.daysUntilRenewal > 37 ? // Up to 50 days
                                    (
                                        user.pipOption > 3 ? 
                                        <>
                                            <h6 style={{ color: '#2C5484', fontWeight: 'bold', fontSize: '1.2em', paddingRight:'140px', marginBottom:(isMobile ? '10px': '') }}>
                                                NOTICE: Renewal Coverage Documents Required
                                            </h6>
                                            <div className='d-flex' style={{ fontSize: '.9em' }}>
                                                <div className='col-3 text-center'>
                                                    <img src="https://assets.cure.com/img/main-site/hourglss-2.png" style={{ width: '90%', maxWidth: '120px' }} />
                                                </div>
                                                <div className='col-9' style={{ paddingRight:(isMobile ? '': '115px'), lineHeight:'1.2' }}>
                                                    Easily upload documents to maintain your coverage. Failure to do so will result in the change to a higher No-Fault PIP option and <strong>increase your premium at time of renewal</strong>.

                                                    <br /><br />
                                                    Renewal Date: <br />
                                                    {formattedDate} 12:01 am

                                                    <br /><br />
                                                    Current Coverage: <br />
                                                    {user.coverageDesc}

                                                    <br /><br />
                                                    A payment will be required to renew your policy. Your Renewal Offer will be sent 37 days prior to the renewal date.

                                                    <br /><br />
                                                </div>
                                            </div>
                                            <div className='text-center col-12'>
                                                <button className='btn btn-primary mb-2' style={buttonStylePrim} onClick={() => handleOnClick(user.renewalToken)}>LET'S GET STARTED</button>
                                                <br/>
                                                <button className='btn btn-primary' style={buttonStyleSec} onClick={() => closeModal()}>REMIND ME LATER</button>
                                            </div>
                                        </> :
                                        null
                                    ) : // Past due
                                    (
                                        user.pipOption > 3 && user.renewalPIPOption < 4 ? // Up to 37 days
                                        <>
                                            <h6 style={{ color: '#2C5484', fontWeight: 'bold', fontSize: '1.2em', paddingRight:'100px', marginBottom:(isMobile ? '40px': '') }}>
                                                NOTICE: Your documents are past due.
                                            </h6>
                                            <div className='d-flex' style={{ fontSize: '.9em' }}>
                                                <div className='col-3 text-center'>
                                                    <img src="https://assets.cure.com/img/main-site/hourglss-1.png" style={{ width: '90%', maxWidth: '120px' }} />
                                                </div>
                                                <div className='col-9' style={{ paddingRight:(isMobile ? '': '115px'), lineHeight:'1.2' }}>
                                                    As of today, we have not received or been able to verify your proof of medical coverage. The result is the PIP selection on your Renewal Offer has changed to a higher No-Fault PIP coverage <strong>at an increased premium as required by Michigan law</strong>.

                                                    <br /><br />
                                                    There is still time to re-establish your preferred coverage option. A payment will be required to renew your policy.

                                                    <br /><br />
                                                    Renewal Date: <br />
                                                    {formattedDate} 12:01 am

                                                    <br /><br />
                                                    Current Coverage: <br />
                                                    {user.coverageDesc}

                                                    <br /><br />
                                                </div>
                                            </div>
                                            <div className='text-center col-12'>
                                                <button className='btn btn-primary mb-2' style={buttonStylePrim} onClick={() => handleOnClick(user.renewalToken)}>LET'S GET STARTED</button>
                                                <br/>
                                                <button className='btn btn-primary' style={buttonStyleSec} onClick={() => closeModal()}>REMIND ME LATER</button>
                                            </div>
                                        </> :
                                        null
                                    )
                                )}
                            </div>
                        </div>
                    </Modal.Body>
                </div>
            </Modal>
        </>
    )
}

const FormatDate = (tempDate) => {
    var dateMonth = `${(tempDate.getMonth() + 1) < 10 ? '0' : ''}${tempDate.getMonth() + 1}`
    var dateDay = `${(tempDate.getDate() + 1) < 10 ? '0' : ''}${tempDate.getDate()}`
    var dateYear = `${tempDate.getFullYear()}`
    const date = `${dateMonth}/${dateDay}/${dateYear}`
    return date
}

export default RenewalAlertModal